import { render, staticRenderFns } from "./AdjustStock.vue?vue&type=template&id=c472ccba&scoped=true"
import script from "./AdjustStock.vue?vue&type=script&lang=js"
export * from "./AdjustStock.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/inventory.css?vue&type=style&index=0&id=c472ccba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c472ccba",
  null
  
)

export default component.exports